import { Guardian } from '@xaamin/guardian';

Guardian.define('account.api-keys', (user) => {
  return user.cliente?.servicios?.cliente_externo !== true && (user.can('api-keys.listar') && user.is(['root', 'owner']));
});

Guardian.define('account.consumo', (user) => {
  return user.cliente?.esquema === 1 && user.is(['root', 'owner']);
});